import { render, staticRenderFns } from "./SmallErrorBox.vue?vue&type=template&id=1c4106bd&scoped=true&"
import script from "./SmallErrorBox.vue?vue&type=script&lang=js&"
export * from "./SmallErrorBox.vue?vue&type=script&lang=js&"
import style0 from "./SmallErrorBox.vue?vue&type=style&index=0&id=1c4106bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4106bd",
  null
  
)

export default component.exports